/**
 * One Tres Commas campaign and its flows, for the Campaigns page detail:
 * GET /tres-commas/campaigns/:id and GET /tres-commas/campaigns/:id/flows, the
 * twins of the Voluum routes (same answers). Read-only. The campaign comes back
 * tagged provider 'tres-commas' (null when unknown), so the page can never
 * read it as a Voluum campaign. 503 while tres-commas is not configured.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';

import api from '@/services/api';
import type { CampaignDetail, Flow } from '@/hooks/voluum/useVoluum';

import { tresCommasKeys } from './keys';

export function useTresCommasCampaign(campaignId: string) {
  return useQuery({
    queryKey: tresCommasKeys.campaign(campaignId),
    queryFn: async (): Promise<CampaignDetail | null> => {
      const response = await api.get<{ data?: CampaignDetail }>(`/tres-commas/campaigns/${campaignId}`);
      const campaign = response.data?.data;
      return campaign ? { ...campaign, provider: 'tres-commas' } : null;
    },
    enabled: !!campaignId,
    staleTime: 60_000,
  });
}

export function useTresCommasCampaignFlows(campaignId: string) {
  return useQuery({
    queryKey: tresCommasKeys.campaignFlows(campaignId),
    queryFn: async () => {
      const response = await api.get<{ data?: Flow[] }>(`/tres-commas/campaigns/${campaignId}/flows`);
      return response.data?.data ?? [];
    },
    enabled: !!campaignId,
    staleTime: 60_000,
  });
}
